<template>
	<div class="body">
		<div class="bg_1">
			<img class="bg-img" src="./assets/images1/select-bg.png" mode="">
			<!-- <img class="select-img" src="./assets/images1/select-img1.png" mode=""> -->
			<img class="select-img" :style="{height:data[index].height + 'rem'}" :src="data[index].url" mode="">
			<div class="info">
				<div class="title">
					企业咨询入口
				</div>
				<div class="title1">
					Enterprise consulting entrance
				</div>

				<div class="footer-img">
					<el-input class="form-item-input" v-model="info.enterpriseName" maxlength="30"
						placeholder="请输入公司名称" />
					<el-input class="form-item-input" v-model="info.userName" maxlength="20" placeholder="请输入您的姓名" />
					<el-input class="form-item-input" v-model="info.userMobile" maxlength="11" placeholder="请输入您的手机号" />
					<v-Linkage v-model="selected" @func="changeArea1" :selected="selected" :mutilstreet="false">
					</v-Linkage>
					<el-input class="form-item-input" v-model="info.enterpriseIndustry" maxlength="50"
						placeholder="请输入所属行业" />

				</div>
				<div class="buts">
					<div class="but" @click="submit">
						提交信息
					</div>
				</div>


			</div>
			<!-- <simple-address ref="simpleAddress" class="simpleAddress" :pickerValueDefault="cityPickerValueDefault" @onConfirm="onConfirm" themeColor="#007AFF">
			</simple-address> -->
		</div>

	</div>
</template>

<script>
import {
	consultAdd
} from '@/api/api.js';

export default {
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'margin:0;')
	},
	data() {
		return {
			index: 0,
			cityPickerValueDefault: [0, 0, 0],
			info: {
				enterpriseName: '', //公司名称
				userName: '', //姓名
				userMobile: '', //联系电话
				province: '', //省份
				city: '',  //城市
				area: '',  //区域
				enterpriseIndustry: '',  //所属行业

			},
			loading: true,
			selected: [],
			area: "",
			data: [
				{

					height: 23.875,
					url: require("./assets/images1/select-img1.png"),

				},
				{
					height: 26.875,
					url: require("./assets/images1/select-img2.png"),
				},
				{
					height: 55.375,
					url: require("./assets/images1/select-img3.png"),
				},
				{
					height: 22.5,
					url: require("./assets/images1/select-img4.png"),
				},
				{
					height: 25.875,
					url: require("./assets/images1/select-img5.png"),
				},
				{
					height: 19,
					url: require("./assets/images1/select-img6.png"),
				},
				{
					height: 30.4375,
					url: require("./assets/images1/select-img7.png"),
				},
				{
					height: 23.84375,
					url: require("./assets/images1/select-img8.png"),
				},
				{
					height: 30.3125,
					url: require("./assets/images1/select-img9.png"),
				},
				{
					height: 67.6875,
					url: require("./assets/images1/select-img10.png"),
				}

			]

		}
	},
	created() {
		this.index = this.$route.query.index

		// this.$nextTick(() => {
		// 	this.index = this.$route.query.index
		// })

	},

	methods: {
		submit() {
			for (const key in this.info) {
				if (!this.info[key]) {
					return this.$message.error("请完整所有信息！")

				}
			}
			consultAdd(this.info).then((res) => {
				//    this.$message.success("新增成功")
				this.$router.go(-1)
				console.log(res)
			})
			// if (this.info.businessIntentName && this.info.businessIntentContact && this.info.businessIntentMobile && this.area) {
			// 	this.info.businessIntentType = 1
			// 	console.log(this.info)
			// 	consultAdd(this.info).then((res) => {

			// 		console.log(res)
			// 	})
			// }

		},
		changeArea1(data) {
			console.log(data)
			this.selected = data;
			this.info.province = this.selected[0];
			this.info.city = this.selected[1];
			this.info.area = this.selected[2];
		},
	}
}
</script>

<style scoped  >
.body {
	width: 100%;
	height: 100%;
	background: rgb(6, 19, 69) !important;

	/* padding-bottom: 150rpx; */
}

.bg_1 {
	padding: 0 3%;
	padding-bottom: .9375rem;
	background: rgb(0, 1, 37);

}

.bg-img {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	min-height: 100vh;

}

.select-img {
	position: relative;
	z-index: 1;
	width: 100%;
	margin: 1.25rem 0;
}

.info {
	position: relative;
	box-sizing: border-box;
	z-index: 2;
	width: 100%;
	background: rgb(6, 38, 107);
	/* background: linear-gradient(0deg, #059DFF 0%, #006DFF 100%); */
	padding: 3%;

	/* opacity: 0.2; */

}

.title {
	text-align: center;
	font-size: 1.375rem;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #FFFFFF;
	text-shadow: 0px .09375rem .21875rem rgba(31, 32, 52, 0.2);
}

.title1 {
	text-align: center;
	margin: .6875rem 0;
	font-size: .75rem;
	font-family: Source Han Sans CN;
	font-weight: 300;
	color: #FFFFFF;
	opacity: 0.2;
}



.form-item-input {
	width: 90%;
	height: 2rem;
	/* padding-left: .9375rem; */
	margin: 0 auto;
	margin-bottom: 1.25rem;
}



.but {
	width: 90%;
	height: 3rem;
	background: linear-gradient(0deg, #006EFF 0%, #059CFF 100%);
	font-size: 1.125rem;
	font-weight: 800;
	color: #FFFFFF;
	text-shadow: 0px .34375rem 1.25rem rgba(255, 161, 26, 0.21);
	border: solid 1px #006EFF;
	background: linear-gradient(0deg, #006EFF 0%, #059CFF 100%);
	border-radius: .3125rem;
	text-align: center;
	line-height: 3rem;
	margin: 0 auto;
}

::v-deep .el-input__inner {
	height: 2.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/index_2.vue